import { useWindowDimensions } from 'react-native';
import { BREAKPOINTS } from '../assets/theme';

/** Responsive flags shared by navigation and screens. */
export function useLayout() {
  const { width, height } = useWindowDimensions();
  const isDesktop = width >= BREAKPOINTS.desktop;
  const isWide = width >= BREAKPOINTS.wide;
  return {
    width,
    height,
    isDesktop,
    isWide,
    isMobile: !isDesktop,
    /** Horizontal page gutter (Airbnb: 24px tablet, 40px+ desktop). */
    gutter: isWide ? 40 : isDesktop ? 24 : 16,
  };
}
